import messagingApp from '@wh/overlay-messaging';
import cookieApp from '@wh/overlay-cookieDisclaimer';
import getLogger from './logger';
import getMessageBus from './messageBusGetter';

const logError = getLogger('error');

const messageBus = getMessageBus();

if (!messageBus) {
  logError('POPOVERS: no messageBus / AnalyticsPubSub found');
}

cookieApp(messageBus);
messagingApp(messageBus);



// WEBPACK FOOTER //
// ./src/main/index.js